import axios from 'axios';
 
export const api = axios.create({
    baseURL: window.Freighthub.apiUrl,
    headers: {
        Authorization: 'Bearer '+window.Freighthub.token
    }
})

export function initGoogleMap(elementId, center, zoom) {
    return new google.maps.Map(document.getElementById(elementId), {
        center: { lat: -41.0, lng: 174.25 },
        zoom: 6,
        disableDefaultUI: true,
    });
}